module.exports = __webpack_public_path__ + "img/huxi_down_code.744306a0.png";